import { z } from "zod/v4";
import { DateUtils } from "../../../primitive-utils";
import { LOCAL_TIME_FORMAT } from "../../../time";
import { REGEX_LOCAL_TIME } from "../base/time-regex";
import { HourSchema, MillisecondSchema, MinuteSchema, SecondSchema, } from "../base/time-schema";
const LocalTimeSchema = z
    .object({
    ...HourSchema.shape,
    ...MinuteSchema.shape,
    ...SecondSchema.shape,
    ...MillisecondSchema.shape,
})
    .refine(({ hour, minute, second, millisecond }) => {
    const date = new Date(2022, 0, 1, hour, minute, second, millisecond);
    return (date.getHours() === hour &&
        date.getMinutes() === minute &&
        date.getSeconds() === second &&
        date.getMilliseconds() === millisecond);
}, {
    error: "存在しない時刻です。",
})
    .brand("Hour")
    .brand("Minute")
    .brand("Second")
    .brand("Millisecond");
const LocalTimeStringSchema = z
    .string()
    .regex(REGEX_LOCAL_TIME, {
    message: "時刻の形式が不正です。",
})
    .transform((val) => {
    const extractRegex = /\d+/g; // 数字を抽出
    const [hour, minute = 0, second = 0, millisecond = 0] = val.match(extractRegex)?.map(Number) ?? [];
    return {
        hour,
        minute,
        second,
        millisecond,
    };
});
/** DateをJST解釈のLocalTimeに変換して返す */
const fromDateJST = (v) => {
    const jstDate = DateUtils.utcToJSTTime(v);
    return fromDate(jstDate);
};
const toDateJST = (v) => {
    return DateUtils.JSTTimeToUtc(toDate(v));
};
/** LocalDate -> string */
const format = (v, format = LOCAL_TIME_FORMAT) => {
    return DateUtils.format(toDate(v), format);
};
/** 形式チェックのみで、厳密な時刻存在チェックを経ないparse */
const parseSoft = (v) => {
    return LocalTimeStringSchema.parse(v);
};
/** 時刻の存在チェックを行い、LocalTimeに変換する */
const parse = (v) => {
    return LocalTimeSchema.parse(parseSoft(v));
};
const equals = (a, b) => {
    return toDate(a).getTime() === toDate(b).getTime();
};
const isAfter = (a, b) => {
    return toDate(a).getTime() > toDate(b).getTime();
};
const isBefore = (a, b) => {
    return toDate(a).getTime() < toDate(b).getTime();
};
/** private */
const toDate = (v) => {
    return new Date(2022, 0, 1, v.hour, v.minute, v.second, v.millisecond);
};
/** private */
const fromDate = (d) => {
    return LocalTimeSchema.parse({
        hour: d.getHours(),
        minute: d.getMinutes(),
        second: d.getSeconds(),
        millisecond: d.getMilliseconds(),
    });
};
export const LocalTime = {
    schema: LocalTimeSchema,
    stringSchema: LocalTimeStringSchema,
    of(args) {
        return LocalTime.schema.parse(args);
    },
    NOW: () => fromDateJST(new Date()),
    ZERO: () => LocalTime.schema.parse({ hour: 0, minute: 0, second: 0, millisecond: 0 }),
    // ** LocalTime <-> Date 変換系 ** //
    toDateJST,
    fromDateJST,
    // ** LocalTime <-> string 変換系 ** //
    format,
    parseSoft,
    parse,
    // ** LocalDateの判定系 ** //
    equals,
    isAfter,
    isBefore,
};
//# sourceMappingURL=local-time.js.map